var ReactParticles = require("./cjs/particles");
for (var key in ReactParticles) {
  ReactParticles.default[key] = ReactParticles[key];
}
module.exports = ReactParticles.default;